/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type NonIndexablePagesRow_issue$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type NonIndexablePagesTable_project$ref: FragmentReference;
export type NonIndexablePagesTable_project = {|
  +host: string,
  +crawls: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +countNoindexTypesNoindexedPages: ?$ReadOnlyArray<?{|
          +type: string,
          +count: number,
        |}>,
        +noindexedPages: ?{|
          +count: number,
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +$fragmentRefs: NonIndexablePagesRow_issue$ref
            |}
          |}>,
        |},
      |}
    |}>
  |},
  +$refType: NonIndexablePagesTable_project$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v1 = {
  "kind": "Variable",
  "name": "sitemapFilter",
  "variableName": "sitemapFilter",
  "type": "SitemapFilter"
},
v2 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "NonIndexablePagesTable_project",
  "type": "Project",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "limit",
      "type": "Int",
      "defaultValue": 20
    },
    {
      "kind": "LocalArgument",
      "name": "url",
      "type": "TextFilters",
      "defaultValue": v0
    },
    {
      "kind": "LocalArgument",
      "name": "sourceUrl",
      "type": "TextFilters",
      "defaultValue": v0
    },
    {
      "kind": "LocalArgument",
      "name": "noindexTypeFilters",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "sitemapFilter",
      "type": "SitemapFilter",
      "defaultValue": {
        "showInSitemap": true,
        "showNotInSitemap": true
      }
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "host",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "crawls",
      "storageKey": "crawls(limit:1,offset:0)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "offset",
          "value": 0,
          "type": "Int"
        }
      ],
      "concreteType": "CrawlsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CrawlsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Crawl",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "countNoindexTypesNoindexedPages",
                  "storageKey": null,
                  "args": [
                    v1,
                    v2,
                    v3
                  ],
                  "concreteType": "CountType",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "type",
                      "args": null,
                      "storageKey": null
                    },
                    v4
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "noindexedPages",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "limit",
                      "variableName": "limit",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "noindexTypeFilters",
                      "variableName": "noindexTypeFilters",
                      "type": "[String]"
                    },
                    {
                      "kind": "Variable",
                      "name": "offset",
                      "variableName": "offset",
                      "type": "Int"
                    },
                    v1,
                    v2,
                    v3
                  ],
                  "concreteType": "NoindexedPageConnection",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "NoindexedPageEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "NoindexedPage",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "NonIndexablePagesRow_issue",
                              "args": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '0a7bc97eace6dfe3ffa37002f1ff9e51';
module.exports = node;
